import BASE_URL from "../config";

// Addresses of the logged-in user (requires an access token).
export const getAddresses = async (token) => {
  const response = await fetch(`${BASE_URL}/addresses`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// Create an address. Works for a logged-in user (token attaches it to their
// account) or a guest checkout (token omitted — the backend's optionalAuth
// middleware still allows an unowned address to be created).
export const createAddress = async (payload, token) => {
  const response = await fetch(`${BASE_URL}/addresses`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

export const updateAddress = async (uuid, payload, token) => {
  const response = await fetch(`${BASE_URL}/addresses/${uuid}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

export const deleteAddress = async (uuid, token) => {
  const response = await fetch(`${BASE_URL}/addresses/${uuid}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};
